import { useMemo, type FC } from "react";
import { AgentExecution_Phase } from "gitpod-next-api/gitpod/v1/agent_pb";
import { Text } from "@/components/podkit/typography/Text";
import type { PlainAgentExecution } from "@/queries/agent-queries";

export const AgentExecutionStatusLabel: FC<{ agentExecution: PlainAgentExecution }> = ({ agentExecution }) => {
    const label = useMemo(() => {
        if (!agentExecution.status?.phase) {
            return null;
        }

        switch (agentExecution.status.phase) {
            case AgentExecution_Phase.RUNNING: // PHASE_RUNNING
                return null;
            case AgentExecution_Phase.WAITING_FOR_INPUT: // PHASE_WAITING_FOR_INPUT
                return "Waiting for input";
            case AgentExecution_Phase.STOPPED: // PHASE_STOPPED
                return agentExecution.status.failureMessage ? "Failed" : "Ready for review";
            default:
                return null;
        }
    }, [agentExecution.status?.failureMessage, agentExecution.status?.phase]);

    if (!label) {
        return null;
    }
    return <Text className="text-sm text-content-secondary">{label}</Text>;
};
